
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const DirectionsPage = () => {
  const businessAddress = "560 Broadway, Passaic, NJ 07055";
  const googleMapsUrl = `https://www.google.com/maps/dir//${encodeURIComponent(businessAddress)}`;
  const appleMapsUrl = `http://maps.apple.com/?daddr=${encodeURIComponent(businessAddress)}`;

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat h-96 flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/c2aed989b778dfb4bd0707f8a9e0243e.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-white">
            <nav className="text-sm mb-4">
              <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">Home</Link>
              <span className="mx-2 text-gray-400">/</span>
              <span className="text-white">Directions</span>
            </nav>
            <h1 className="text-5xl font-bold">Find Sagil Service</h1>
            <p className="text-xl mt-4">Easy directions to our auto repair shop in Passaic, NJ</p>
          </div>
        </div>
      </section>

      {/* Directions Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Address and Contact Info */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Visit Our Shop</h2>
              
              {/* Address Card */}
              <div className="bg-white rounded-lg shadow-lg p-8 mb-8 border border-gray-200">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-red-700 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-map-pin-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Our Address</h3>
                    <p className="text-lg text-gray-700">{businessAddress}</p>
                  </div>
                </div>

                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-red-700 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-phone-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Phone</h3>
                    <a href="tel:(973) 472-0890" className="text-lg text-red-700 hover:text-red-600 cursor-pointer">
                      (973) 472-0890
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-red-700 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-time-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Hours</h3>
                    <div className="text-gray-700">
                      <p>Monday - Friday: 7:00 AM - 6:00 PM</p>
                      <p>Saturday: 7:00 AM - 5:00 PM</p>
                      <p>Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation Buttons */}
              <div className="space-y-4">
                <a
                  href={googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center px-6 py-4 bg-red-700 hover:bg-red-600 text-white rounded-lg font-semibold transition-colors cursor-pointer"
                >
                  <i className="ri-navigation-line mr-3 text-xl"></i>
                  Get Directions via Google Maps
                </a>
                
                <a
                  href={appleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center px-6 py-4 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-semibold transition-colors cursor-pointer"
                >
                  <i className="ri-map-2-line mr-3 text-xl"></i>
                  Get Directions via Apple Maps
                </a>
              </div>

              {/* Landmarks */}
              <div className="mt-8 bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Nearby Landmarks</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <i className="ri-building-line mr-2 text-red-700"></i>
                    Located on Broadway in Passaic
                  </li>
                  <li className="flex items-center">
                    <i className="ri-parking-line mr-2 text-red-700"></i>
                    Convenient parking available
                  </li>
                  <li className="flex items-center">
                    <i className="ri-road-map-line mr-2 text-red-700"></i>
                    Easy access from Route 21 and Route 3
                  </li>
                </ul>
              </div>
            </div>

            {/* Map */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Location Map</h2>
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <iframe
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dOWTgHz-y-2b8s&q=${encodeURIComponent(businessAddress)}`}
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Sagil Service Location"
                ></iframe>
              </div>

              {/* Driving Directions */}
              <div className="mt-8 bg-white rounded-lg shadow-lg p-6 border border-gray-200">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Driving Directions</h3>
                <div className="space-y-4 text-gray-700">
                  <div>
                    <h4 className="font-semibold text-gray-900">From Route 21 North:</h4>
                    <p>Take Exit 8 for Broadway/Passaic. Turn right onto Broadway. We'll be on your right.</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">From Route 21 South:</h4>
                    <p>Take Exit 8 for Broadway/Passaic. Turn left onto Broadway. We'll be on your right.</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">From Route 3:</h4>
                    <p>Take the Passaic Avenue exit and follow signs to Broadway. Turn onto Broadway and we'll be on your left.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Visit Us?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Schedule your service appointment today or give us a call. We're here to help with all your automotive needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>
              Schedule Service
            </Link>
            <a 
              href="tel:(973) 472-0890" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (973) 472-0890
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DirectionsPage;
